import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBriefcase } from '@fortawesome/free-solid-svg-icons';
import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import '../assets/styles/Timeline.scss'

function Timeline() {
  return (
    <div id="parcours">
      <div className="items-container">
        <h1>Histoire de carrière</h1>
        <VerticalTimeline>
          <VerticalTimelineElement visible={true}
            className="vertical-timeline-element--work"
            contentStyle={{ background: 'white', color: 'rgb(39, 40, 34)' }}
            contentArrowStyle={{ borderRight: '7px solid  white' }}
            date="Octobre 2016 - Février 2017"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h2 className="vertical-timeline-element-title royal-blue">
              <a target="_blank" className="royal-blue" href="https://www.adkontact.com/">AdKontact</a>
            </h2>
            <h3 className="vertical-timeline-element-title italic">Développeur web Full-stack</h3>
            <h4 className="vertical-timeline-element-subtitle">Lomé, Togo</h4>
            <p>

              Adkontact est une entreprise internationnale dont le siège se trouve à paris, spécialisée dans la gestion de la relation clien
              Adkontact est une entreprise internationnale dont le siège se trouve à paris, spécialisée dans la gestion de la relation clien

              Adkontact est une entreprise internationale dont le siège se trouve à Paris,
              spécialisée dans la gestion de la relation client. J’ai eu à
              collaborer avec la directrice et le project manager pour la création
              d’une application web permettant aux téléopérateurs d’enregistrer
              leurs interactions avec des clients de diverses entreprises comme
              des banques (ECOBANK, ORABANK ...) et assurances

            </p>
            <p>
              <span className="color-blue">Technologies utilisées</span>: Laravel, Jquerry, MysQl, Bootstrap,
              MaatwebsiteExcel, Ajax
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="Février 2017 - aujourdh'ui"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >

            <h2 className="vertical-timeline-element-title royal-blue">Devidia</h2>
            <h3 className="vertical-timeline-element-title italic">Développeur web Full-stack</h3>
            <h4 className="vertical-timeline-element-subtitle">Toulouse, France (Télétravail)</h4>
            <p>
              Devidia est une agence web basée à Toulouse ou j’ai eu à
              travailler sur divers projets d’application web ou mobile pour
              diverses entreprises Françaises
            </p>
            <p>
              <span className="color-blue">
                Technologies utilisées</span>: Laravel, Angular ,Vue.js, Express
                ,Polr, Firebase, Symfony, MySql, PostgreSql,Mongodb
                Docker, Docker-compose, Prestashop, Wordpress, Git
                workflows, Google cloud, Cypress, GoogleAppScript, Debian,
                Ubuntu ...

            </p>

          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="Décembre 2020 – Octobre 2021"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h2 className="vertical-timeline-element-title royal-blue">
              <a target="_blank" className="royal-blue" href="https://thecodingmachine.com/">TheCodingMachine</a>
            </h2>
            <h3 className="vertical-timeline-element-title italic">Développeur web Full-stack</h3>
            <h4 className="vertical-timeline-element-subtitle">Paris, France (Télétravail)</h4>
            <p>
              TheCodingMachine est une agence web digitale basée à Paris. J’ai
              eu à travailler en collaboration et en équipe pour la réalisation d’une
              d’application web permettant de faire des audits financiers destinée
              à l’entreprise d’audit Mazars

            </p>
            <p>
              <span className="color-blue">
                Technologies utilisées</span>: Nuxt, Sympony GraphQl, ORM TDBM,
              Docker-compose, Git workflows,Cypress, Behat
            </p>
          </VerticalTimelineElement>

          <VerticalTimelineElement
              className="vertical-timeline-element--work"
              date="Aout 2023 - Janvier 2024"
              iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
              icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h2 className="vertical-timeline-element-title royal-blue">
              <a target="_blank" className="royal-blue" href="https://www.adkontact.com/">Socium</a>
            </h2>
            <h3 className="vertical-timeline-element-title italic">Développeur web Full-stack</h3>
            <h4 className="vertical-timeline-element-subtitle">Paris, France (Télétravail)</h4>
            <p>
              Socium, est une startup qui crée des solutions RH adaptées
              aux entreprises en Afrique basée a Dakar. j’ai eu à travailler
              en équipe pour la création d’un module d’évaluation
              d’employés et de sondage

            </p>
            <p>
              <span className="color-blue">
                Technologies utilisées</span>: Angular, Nest.js GraphQl, MongoDb,
              formly, Azure DevOps, Git workflows, keyKloack, SSO
            </p>
          </VerticalTimelineElement>
        </VerticalTimeline>
      </div>
    </div>
  );
}

export default Timeline;